/* Copyright (c) 2023 GRIP.S Medien GmbH & Co.KG */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import FourOhThree from './403';
import FourOhFour from './404';

class Switcher extends Component {
  static propTypes = {
    viewProps: PropTypes.object,
  };

  check = (routeScopes) => {
    // check for scopes of user, exit if empty scopes
    const { scopes } = this.props;
    if (!scopes || scopes.length === 0) return false;

    // look for scope, if not existing exit
    const foundScopes = routeScopes.filter((routeScope) =>
      scopes.find((scope) => scope === routeScope),
    );
    if (foundScopes.length) return false;

    // scope existing
    return true;
  };

  render() {
    const { viewProps, routes } = this.props;
    return (
      <Switch>
        {routes.map((route) => {
          // exit if scope is false
          let Handler = route.handler;
          if (this.check(route.scopes)) Handler = FourOhThree;
          return (
            <Route
              exact={route.exact}
              path={route.path}
              render={() => <Handler {...viewProps} {...route.props} />}
              key={route.path}
            />
          );
        })}

        <Route
          exact={false}
          path='/'
          render={() => <FourOhFour {...viewProps} />}
          key='404'
        />
      </Switch>
    );
  }
}

export default Switcher;
